module.exports = __webpack_public_path__ + "assets/img/home-main-content-bg1.36081e7d.png";